import React from "react";
import moment from "moment";
import type { IMemoryDetail } from "service/interface/memory";

interface Props {
  data: IMemoryDetail;
}

export function ContactInfoTable({ data }: Props) {
  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          신청 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            서비스 선택
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            {data.selectedService}
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            청소 서비스
          </div>
          <div className="flex h-full w-[303px] items-center px-[12px] text-M3 text-gray-5">
            {data.isCleanService}
          </div>
        </div>
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            주소
          </div>
          <div className="flex h-full w-[318px] items-center px-[12px] text-M3 text-gray-5">
            {data.address}
          </div>
          <div className="flex h-full w-[164px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            면적(평)
          </div>
          <div className="flex h-full w-[303px] items-center px-[12px] text-M3 text-gray-5">
            {data.area}
          </div>
        </div>
        <div className="flex h-[190px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            기타
          </div>
          <div className="flex h-full w-[790px] items-center px-[12px] text-M3 text-gray-5">
            <textarea
              readOnly
              value={data.etc}
              className="m-0 h-[166px] w-full resize-none border-none p-0 focus:ring-white"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
